<app-header></app-header>
<app-announcement></app-announcement>

<!-- Global Search -->
<div class="searchmain mb-2">
  <input #TransactionGlobalSearch
         type="text"
         pInputText
         placeholder="Search..."
         class="searchbox"
         (input)="dtTrans.filterGlobal($event.target.value, 'contains')" />
  <i class="fa fa-search search_modified"></i>
</div>

<!-- PrimeNG 14 Table -->
<p-table #dtTrans
         id="chaseTransactionLogs"
         [value]="getChaseTransactionDetails"
         [paginator]="true"
         [rows]="10"
         [rowsPerPageOptions]="[10,20,50]"
         [loading]="loadingChaseTransactionLogs"
         [reorderableColumns]="true"
         [resizableColumns]="true"
         [tableStyle]="{
            'table-layout':'fixed',
            'width':'100%',
            'border-collapse':'collapse',
            'border':'1px solid #c5c5c5',
            'min-width':'1250px'
          }"
         [globalFilterFields]="[
           'requestTime',
           'responseTime',
           'chaseOrderId',
           'transactionType',
           'request',
           'response'
         ]">

  <!-- Table Header -->
  <ng-template pTemplate="header">
    <tr>
      <th style="width:160px;">Request Time</th>
      <th style="width:160px;">Response Time</th>
      <th style="width:160px;">Chase Order Id</th>
      <th style="width:160px;">Transaction Type</th>
      <th style="width:300px;">Request</th>
      <th style="width:300px;">Response</th>
    </tr>
  </ng-template>

  <!-- Table Body -->
  <ng-template pTemplate="body" let-row>
    <tr>
      <td>{{ row.requestTime }}</td>
      <td>{{ row.responseTime }}</td>
      <td>{{ row.chaseOrderId }}</td>
      <td>{{ row.transactionType }}</td>
      <td>
        <textarea class="w-100" readonly>{{ row.request }}</textarea>
      </td>
      <td>
        <textarea class="w-100" readonly>{{ row.response }}</textarea>
      </td>
    </tr>
  </ng-template>

  <!-- Empty message -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6" class="text-center">No Record Found!</td>
    </tr>
  </ng-template>
</p-table>
